import { Popup } from './Popup';
import { AktivitetTemplate } from './GridAktiviteter';
import { Utils } from '../Utils';
import * as _ from "underscore";
import * as moment from "moment";

export class KopiereAktiviteterTilPlan {
    planId: number = -1;
    form: DevExpress.ui.dxForm;
    popup: Popup;
    schedItems: any = [];
    schedItemsNew: any = [];
    schedulerFrom: DevExpress.ui.dxScheduler;
    schedulerTo: DevExpress.ui.dxScheduler;
    planStart: Date;
    planEnd: Date;
    forfallsDager: number;
    selectedPlan: number = null;
    selectedPlanStart: Date;
    refreshGrid: Function;
    listFlyttet: DevExpress.ui.dxList;
    flyttetAktiviteter: any[] = [];
    canSave: boolean = false;

    constructor(planId: number, planNavn: string, refresh: Function) {
        this.planId = planId;
        this.refreshGrid = refresh;

        let title = '<div class="p-header"><i class="fa fa-clone"></i>Kopiere aktiviteter til plan...</div>';
        let container = $("<div>");
        $("<div>").attr("id", "form").appendTo(container);
        // Left Scheduler
        let sdiv = $("<div>").css({ float: "left", width: "40%", padding: "10px 0" });
        $("<div>").attr("id", "scheduler1").appendTo(sdiv);
        sdiv.appendTo(container);
        // Middle area
        sdiv = $("<div style='float:left;margin:10px 5px 0px 5px;width:188px;height:402px;'>");
        $("<div id='box-1' style='padding:2px;width:100%;height:100px;border:1px solid #ddd;' class='box-shadow'/>")
            .appendTo(sdiv);
        $("<div id='box-2' style='padding:2px;width:100%;height:293px;border:1px solid #ddd;margin-top:8px;' class='box-shadow'/>").appendTo(sdiv);
        $("<div>").attr("id", "middle").css("padding", "10px").appendTo(sdiv);
        sdiv.appendTo(container);
        // Right Scheduler
        sdiv = $("<div>").css({ "float": "right", "width": "40%", padding: "10px 0" });
        $("<div>").attr("id", "scheduler2").appendTo(sdiv);
        sdiv.appendTo(container);
        $("<div style=\"height:1px; border-top:1px solid silver;margin-bottom:10px;clear:both;\"/><div id='spinner90'/>")
            .appendTo(container);
        let buttonContainer = $("<div>").css("float", "right");
        $("<div>").attr("id", "cancel").appendTo(buttonContainer);
        $("<div>").attr("id", "ok").appendTo(buttonContainer);
        buttonContainer.appendTo(container);
        var popupOptions = {
            width: 1024,
            height: 620,
            animation: null,
            contentTemplate: container,
            showTitle: true,
            titleTemplate: '<div class="p-header"><i class="fa fa-tasks"></i>Kopi aktiviteter til plan: ' + planNavn + '</div>',
            visible: false,
            dragEnabled: true,
            closeOnOutsideClick: false,
            showCloseButton: true
        };
        this.popup = new Popup(popupOptions);

        this.createThePopup();
    }

    createThePopup() {
        const self: KopiereAktiviteterTilPlan = this;

        $.get("/Plan/GetPlanAndProsess",
            { planId: self.planId },
            (result) => {
                self.planStart = new Date(result.plan.startDato);
                self.planEnd = new Date(result.plan.sluttDato);

                var col0 = [
                    {
                        dataField: "planId",
                        label: { text: "Fra plan" },
                        editorType: "dxSelectBox",
                        editorOptions: {
                            dataSource: [],
                            placeholder: "Velg plan for å kopiere fra...",
                            valueExpr: "id",
                            displayExpr: "navn",
                            searchEnabled: true,
                            searchExpr: "navn",
                            searchMode: 'startswith',
                            width: 344,
                            onValueChanged: (e) => {
                                if (e.value) {
                                    this.newPlan(e.value);
                                }
                            }
                        }
                    }, {
                        dataField: "aktiviteter",
                        label: { text: "Aktivitet" },
                        editorType: "dxSelectBox", 
                        editorOptions: {
                            dataSource: [],
                            placeholder: "Velg aktivitet...",
                            valueExpr: "id",
                            disabled: self.selectedPlan === null,
                            displayExpr: "aktivitetsItem.navn",
                            searchEnabled: true,
                            searchExpr: "aktivitetsItem.navn",
                            searchMode: 'startswith', 
                            width: 344,
                            onValueChanged: (e) => {
                                this.addAktiviteter(e.value);
                            }
                        }
                    }
                ];
                const col1 = [
                    {
                        dataField: "prosess",
                        label: { text: "Prosess" },
                        editorType: "dxTagBox",
                        editorOptions: {
                            dataSource: result.prosess,
                            placeholder: "Velg prosess...",
                            valueExpr: "id",
                            displayExpr: "navn",
                            showSelectionControls: true,
                            searchEnabled: true,
                            searchExpr: "navn",
                            searchMode: 'startswith',
                            width: 505,
                            onValueChanged: (e) => {
                                this.newPlan(self.selectedPlan);
                            }
                        }
                    }
                    //{
                    //    title: "Brukere",
                    //    template: (data, itm) => {
                    //        let html = "<table><tr>";
                    //        result.prosess.forEach((itm) => { 
                    //            html += '<td class="pl-10"><div id="' + itm.navn.substring(0, 2) + '"/></td><td class="pl-4">' + itm.navn.substring(0,2) + '</td>';
                    //        });
                    //        html += '</tr></table>';
                    //        itm.append(html);
                    //        result.prosess.forEach((itm) => {
                    //            $("#" + itm.navn.substring(0, 2)).dxCheckBox({
                    //                value: true
                    //            });
                    //        });
                    //    }
                    //}
                ];
                var c1 = [{ itemType: "group", items: col0 }, {itemType: "group", items: col1 }];
                this.popup.show();
                self.form = $("#form")
                    .dxForm({
                        //showColonAfterLabel: true,
                        //labelLocation: "top",
                        colCount: 3,
                        //formData: formData,
                        items: c1
                    })
                    .dxForm("instance");

                this.createScheduler();
                this.createMiddle();

                $("#cancel")
                    .dxButton({
                        text: "Lukk vindu",
                        height: 30,
                        width: 200,
                        icon: 'close',
                        onClick: () => {
                            self.popup.hide();
                        }
                    });

                $("#ok")
                    .dxButton({
                        text: "Lagre til plan",
                        type: "success",
                        icon: 'save',
                        disabled: !self.canSave,
                        height: 30,
                        width: 200,
                        onClick: () => {
                            self.saveAktiviteter();
                            self.popup.hide();
                        }
                    });
            });
    }

    newPlan(planId: number) {
        var self: KopiereAktiviteterTilPlan = this;
        var prosess: any[] = (<any>self.form.getEditor("prosess")).option("selectedItems");
        Utils.wait();
        $.get("/Plan/GetPlan",
            { planId },
            (plan) => {
                const start = new Date(plan.startDato);
                const slutt = new Date(plan.sluttDato);
                self.selectedPlanStart = start;
                self.schedulerFrom.option('min', start);
                self.schedulerFrom.option('max', slutt);
                self.schedulerFrom.option('currentDate', new Date(plan.startDato));
                self.schedulerFrom.option('disabled', false);              
                $.getJSON("/Plan/GetAktiviteter",
                    { planId: planId },
                    (data) => {
                        let editor = <any>this.form.getEditor("aktiviteter");
                        if (prosess.length > 0) {
                            data = _.filter(data, (itm: any) => {
                                let exists = _.find(prosess, (prs: any) => {
                                    return itm.aktivitetsItem.prosess.id === prs.id;
                                });
                                return exists;
                            });                           
                        }
                        editor.option("dataSource", data);
                        editor.option("disabled", false);
                        Utils.finished();
                    });
                self.schedItems = [];
                Utils.getRedDaysFor(start, slutt)
                    .forEach((day: any) => {
                        self.schedItems.push({
                            id: -1,
                            aktivitet: null,
                            startDate: day.day,
                            endDate: day.day,
                            text: day.txt,
                            allDay: true,
                            ownerId: [1],
                            visible: true
                        });
                        self.schedulerFrom.option("dataSource", self.schedItems);
                    });
                self.forfallsDager = plan.selskap.forfallDager;
                self.selectedPlan = plan.id;
            });
    }

    getKopiAkt(aktId: number): any[] {
        let ans: any[] = [];
        for (let i = 0; i < this.schedItemsNew.length; i++) {
            let itm = this.schedItemsNew[i];
            if (itm.id > 0 && itm.aktivitet && itm.aktivitet.hovedAktivitetId === aktId) {
                ans.push(itm.aktivitet);
            }
        }
        return ans;
    }

    isEmpty(dato: Date): boolean {
        var itm = _.find(this.schedItemsNew,
            (p: any) => {
                return Utils.sameNoTime(p.startDate, dato);
            });
        if (itm && itm.id > 0)
            return false;
        return true;
    }

    nextEmptyDato(dato: Date): Date {
        let newDate = new Date(dato.toString());
        while (Utils.isInvalidDate(newDate) || !this.isEmpty(newDate)) {
            newDate.setDate(newDate.getDate() + 1);
        }
        return newDate;
    }

    //getValidDate(dager: number, start: Date): Date {
    //    let dato = moment(start).add(dager, "days");
    //    //const year = this.planStart.getFullYear();
    //    //const mon = this.planStart.getMonth();
    //    let dato = new Date(start.toString());
    //    dato.setFullYear(year);
    //    dato.setMonth(mon);
    //    if (lastGoodDay && start < lastGoodDay)
    //        dato = lastGoodDay;
    //    return this.nextEmptyDato(dato);
    //}

    flyttDato(lastOrgDay: Date, newOrgDay: Date, lastNewDay: Date): Date {
        let dager = 0;
        if (lastOrgDay != null)
            dager = moment(newOrgDay).diff(moment(lastOrgDay), "days"); 
        if (lastNewDay == null) {
            let orgDato = new Date(newOrgDay.toString());
            let monOffset = orgDato.getMonth() - this.selectedPlanStart.getMonth(); 
            const year = this.planStart.getFullYear();
            const mon = this.planStart.getMonth() + monOffset;
            let dato = new Date(newOrgDay.toString());
            dato.setFullYear(year);
            dato.setMonth(mon);
            lastNewDay = dato;
        }
        let dato = moment(lastNewDay).add(dager, "days");
        let newdato = this.nextEmptyDato(dato.toDate());

        //if (lastGoodDay && start < lastGoodDay)
        //    dato = lastGoodDay;
        return newdato;
    }

    flyttAktiviteter(aktId: number) {
        var self: KopiereAktiviteterTilPlan = this;
        var lastOrgDay: Date = null;
        var lastNewDay: Date = null;
        var dager = 0;
        self.schedItems.forEach((itm) => {
            if (itm.id > 0) {
                let dato = this.flyttDato(lastOrgDay, itm.startDate, lastNewDay);               
                lastOrgDay = itm.startDate;
                lastNewDay = dato;
                var newAkt = {
                    id: itm.id,
                    aktivitet: itm.aktivitet,
                    startDate: dato,
                    endDate: dato,
                    text: itm.text,
                    allDay: true,
                    ownerId: itm.ownerId,
                    visible: true
                };
                self.schedItemsNew.push(newAkt);
            }
        });
        self.schedulerTo.option("dataSource", self.schedItemsNew);
        self.schedulerTo.repaint();
        this.addToFlyttet();
    }

    addToFlyttet() {
        $("#btnFlytt").dxButton("instance").option("disabled", true);
        $("#btnLagre").dxButton("instance").option("disabled", false);
        for (let i = 0; i < this.schedItemsNew.length; i++) {
            const itm = this.schedItemsNew[i];
            if (itm.id > 0 && itm.aktivitet && itm.aktivitet.hovedAktivitetId === -1) {
                let fitm = {
                    txt: itm.aktivitet.aktivitetsItem.navn,
                    itm: itm,
                    kopi: this.getKopiAkt(itm.id),
                    allItems: this.schedItemsNew
                };
                this.flyttetAktiviteter.push(fitm);
                break;
            }
        }
    }

    getAktiviteter(planId: number) {
        $.getJSON("/Plan/GetAktiviteter",
            { planId: planId },
            (data) => {
                let editor = <any>this.form.getEditor("aktiviteter");
                editor.option("dataSource", data);
            });
    }

    addAktiviteter(aktId: number) {
        var self: KopiereAktiviteterTilPlan = this;
        
        $.getJSON("/Plan/GetAlleAktiviteter",
            { aktId: aktId },
            (data) => {
                var arr = self.schedItems;
                data.forEach((akt: AktivitetTemplate) => {
                    arr.push({
                        id: akt.id,
                        aktivitet: akt,
                        startDate: akt.dato,
                        endDate: akt.dato,
                        text: akt.aktivitetsItem.navn,
                        allDay: true,
                        ownerId: [akt.hovedAktivitetId < 0 ? 2 : 3],
                        visible: true
                    });
                });
                self.schedulerFrom.option("dataSource", arr);
                $("#btnFlytt").dxButton("instance").option("disabled", false);
            });
    }

    clearAktiviteter(aktId: number) {
        var self: KopiereAktiviteterTilPlan = this;
        $.getJSON("/Plan/GetAlleAktiviteter",
            { aktId: aktId },
            (data) => {
                self.schedItems = _.filter(self.schedItems,
                    (itm: any) => {
                        return itm.aktivitet == null ||
                            (itm.aktivitet.id !== aktId && itm.aktivitet.hovedAktivitetId !== aktId);
                    });
                self.schedulerFrom.option("dataSource", self.schedItems);
            });
    }

    clearAktivites(data: any[]): any {
        var arr = [];
        for (let i = 0; i < data.length; i++) {
            let itm = data[i];
            if (itm.id < 0) {
                arr.push(itm);
            }
        }
        return arr;      
    }

    createMiddle() {
        const self: KopiereAktiviteterTilPlan = this;
        //let html = "<table>";
        //html += "<tr><td style='padding:4px'>Fra:</td><td style='padding:4px'><div id='nyFra' /></td></tr>";
        //html += "<tr><td style='padding:4px'>Til:</td><td style='padding:4px'><div id='nyTil' /></td></tr>";
        //html += "<tr><td style='padding:4px'>Farge:</td><td style='padding:4px'><div id='colorbox' /></td></tr>";
        //html += "</table>";
        let html = "<div class='btn-icon-right' style='margin:8px' id='btnFlytt'/>";
        html += "<div class='btn-icon-right' style='margin:8px' id='btnLagre'/>";
        $("#box-1").html(html);
        //$("#middle").parent().height(100);
        //$("#nyFra").dxDateBox({
        //    value: new Date(),        
        //    format: 'dd.MM.yyyy',
        //    width: 115
        //});
        //$("#nyTil").dxDateBox({
        //    value: new Date(),
        //    format: 'dd.MM.yyyy',
        //    width: 115
        //});
        //$("#colorbox").dxColorBox({
        //    width: 115
        //});
        $("#btnFlytt").dxButton({
            text: "Legg til aktivitet",
            type: "default",
            icon: 'fa fa-arrow-right',
            disabled: true,
            width: 166,
            onClick: () => {
                let editor = <any>self.form.getEditor("aktiviteter");
                let akt = editor.option("value");
                self.flyttAktiviteter(akt);
            }
        });
        $("#btnLagre").dxButton({
            text: "Lagre flytting",
            type: "success",
            icon: 'fa fa-arrow-down',
            disabled: true,
            width: 166,
            onClick: () => {
                this.listFlyttet.option("dataSource", this.flyttetAktiviteter);
                this.schedItems = this.clearAktivites(this.schedItems);
                this.schedulerFrom.option("dataSource", this.schedItems);
                this.schedItemsNew = this.clearAktivites(this.schedItemsNew);
                this.schedulerTo.option("dataSource", this.schedItemsNew);
                self.canSave = true;
                $("#ok").dxButton("instance").option("disabled", false);
            }
        });

        html = "<div style='padding:4px; border-bottom: 1px solid #ddd;text-align:center;font-weight:bold;'>Flyttet aktiviteter</div>";
        html += "<div style='margin:0px' id='lstAkt'/>";
        $("#box-2").html(html);
        this.listFlyttet = $("#lstAkt").dxList({
            dataSource: this.flyttetAktiviteter,
            height: 300,
            width: 180,
            allowItemDeleting: true,
            itemDeleteMode: "toggle",
            showSelectionControls: false,
            //selectionMode: "multiple",
            noDataText: "Ingen aktivitet flyttet",
            itemTemplate: (data, index) => {
                var result = $("<div title='" + data.txt + "'>" + data.txt + "</div>");
                return result;
            },
            onItemClick: (e) => {
                self.schedItemsNew = self.clearAktivites(self.schedItemsNew);
                self.schedulerTo.option("dataSource", e.itemData.allItems);
            },
            onItemDeleted: (e) => {
                self.flyttetAktiviteter = self.flyttetAktiviteter;
            }
        }).dxList("instance");
    }

    saveAktiviteter() {
        var self: KopiereAktiviteterTilPlan = this;
        for (let i = 0; i < self.flyttetAktiviteter.length; i++) {
            let fitm = self.flyttetAktiviteter[i];
            $.post('/Plan/KopiToPlan',
                {
                    fromPlan: this.selectedPlan,
                    toPlan: this.planId,
                    aktId: fitm.itm.id,
                    kopi: fitm.kopi,
                    newDato: fitm.itm.startDate.toUTCString(),
                    forfallsDager: this.forfallsDager
                },
                () => {})
                .fail((xhr, textStatus, errorThrown) => {
                    DevExpress.ui.notify("Aktivitet var ikke lagret !", "error", 2000);
                });
        }
        DevExpress.ui.notify("Aktiviteter flyttet !", "success", 2000);
        setTimeout(() => self.refreshGrid(), 1000);
    }

    createScheduler() {
        const self: KopiereAktiviteterTilPlan = this;
        var resourcesData = [
            {
                id: 1,
                text: "Helgedag",
                color: "red"
            },
            {
                id: 2,
                text: "Hovedaktivitet",
                color: "#56ca85"
            },
            {
                id: 3,
                text: "Kopiaktivitet",
                color: "#1e90ff"
            }
        ];

        Utils.getRedDaysFor(self.planStart, self.planEnd).forEach((day: any) => {
            self.schedItemsNew.push({
                id: -1,
                aktivitet: null,
                startDate: day.day,
                endDate: day.day,
                text: day.txt,
                allDay: true,
                ownerId: [1],
                visible: true
            });
        });

        self.schedulerFrom = $("#scheduler1").dxScheduler({
            dataSource: self.schedItems,
            views: ["month"],
            currentView: "month",
            disabled: true,
            currentDate: new Date(),
            useDropDownViewSwitcher: false,
            firstDayOfWeek: 0,
            startDayHour: 6,
            endDayHour: 17,
            resources: [{
                field: "ownerId",
                allowMultiple: true,
                dataSource: resourcesData,
                label: "Owner"
            }],
            width: "100%",
            height: 400
        }).dxScheduler("instance");

        self.schedulerTo = $("#scheduler2").dxScheduler({
            dataSource: self.schedItemsNew,
            views: ["month"],
            currentView: "month",
            currentDate: self.planStart,
            min: this.planStart,
            max: this.planEnd,
            useDropDownViewSwitcher: false,
            firstDayOfWeek: 0,
            startDayHour: 6,
            endDayHour: 17,
            resources: [{
                field: "ownerId",
                allowMultiple: true,
                dataSource: resourcesData,
                label: "Owner"
            }],
            width: "100%",
            height: 400
        }).dxScheduler("instance");
        setTimeout(() => {
            self.schedulerFrom.repaint();
            self.schedulerTo.repaint();
        }, 500);

        $.getJSON("/Plan/GetAllPlanner", { planId: this.planId }, (data) => {
            let editor = <any>self.form.getEditor("planId");
            editor.option("dataSource", data);
            self.schedulerFrom.option("dataSource", self.schedItems);
        });        
    }
}


// WEBPACK FOOTER //
// ./TS/Plan/KopiereAktiviteterTilPlan.ts